(function () {
  function filterMediaByVariant(variant) {
    if (!variant) return;

    const variantId = variant.id.toString();
    const mediaItems = document.querySelectorAll('[data-media-id]');

    let firstVisible = null;

    mediaItems.forEach(item => {
      const ids = item.dataset.variantIds;

      if (!ids || ids === '') {
        item.style.display = '';
        if (!firstVisible) firstVisible = item;
        return;
      }

      if (ids.split(',').includes(variantId)) {
        item.style.display = '';
        if (!firstVisible) firstVisible = item;
      } else {
        item.style.display = 'none';
      }
    });

    if (firstVisible) {
      firstVisible.scrollIntoView({ behavior: 'instant', block: 'nearest' });
    }
  }

  // Escuchar evento estándar de Shopify/Dwell
  document.addEventListener('variant:change', function (event) {
    filterMediaByVariant(event.detail.variant);
  });

  // Fallback: al cargar página
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    const input = form.querySelector('[name="id"]');

    if (!input) return;

    fetch(window.location.href + '.js')
      .then(r => r.json())
      .then(product => {
        if (!product || !product.variants) return;

        const variant = product.variants.find(v => v.id == input.value);

        if (variant) {
          filterMediaByVariant(variant);
        }
      });
  });
})();
